// type和初始值initialState
export interface CommonProps {
    domain: string;
    site: string;
    siteId: number;
}

export type State = CommonProps;

export type Action = {
    setCommonData: (domain: string) => void;
};
export type Common = State & Action;

export const initialState: State = {
    domain: "",
    site: "",
    siteId: 0,
};
